//TODO: Remove when strict mode warnings have been solved
import React from "react"

const StrictMode = process.env.REACT_APP_STRICT_MODE === "true" ? React.StrictMode : React.Fragment

export default StrictMode
